<!--
 * @Description: 
 * @Author:  
 * @Date: 2024-07-31 09:12:06
 * @LastEditTime: 2024-09-10 17:25:15
 * @LastEditors:  
-->
<template>
  <div class="mobile-container">
    <page-header>{{'演讲嘉宾' | dealLanguage('Speaker')}}</page-header>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item in assort_list" :key="index + 'assort'" :class="{'filter-tag-active' : item == active_assort}" @click="changeAssort(item)">
        {{item}}
      </div>
    </div>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item in date_list" :key="index + 'date'" :class="{'filter-tag-active' : item == active_date}" @click="changeDate(item)">
        {{item}}
      </div>
    </div>
    <van-tabs scrollspy sticky title-inactive-color="#999" title-active-color="#333" offset-top="1.22rem">
      <van-tab v-for="item in froum_list" :title="item.activityName" :key="item.activityId">
        <div class="froum-wrapper">
          <div class="froum-base">
            <p>{{item.dateName}}-{{item.activityName}}</p>
            <p class="location"><i class="iconfont">&#xe672;</i>{{item.forumPlace}}</p>
          </div>
          <div class="froum-speakers">
            <div class="froum-speakers-item" v-for="g_item in item.guestDtoList" :key="item.activityId + g_item.id" @click="goDetail(g_item.id)">
              <div class="speaker-img">
                <div class="photo">
                  <img :src="g_item.logoUrl | logo_show" />
                </div>
                <!-- <div class="logo">
                  <img src="https://cdn.vbdata.cn/upload/entity/98e1dc77838bd21fe216a95ffb30e17084.PNG" />
                </div> -->
              </div>
              <div class="speaker-info">
                <div class="speaker-name">
                  <span></span>
                  {{g_item.name}}
                </div>
                <div class="speaker-title">{{g_item.companyPosition}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import { getActExhibitionGuest } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '演讲嘉宾' : 'Speaker',
    }
  },
  inject: ['wxShare'],
  data() {
    return {
      froum_list: [],
      assort_list: [filter.dealLanguage('全部分类', 'All meetings')],
      date_list: [filter.dealLanguage('全部时间', 'All time')],
      first_load: 0,
      active_assort: filter.dealLanguage('全部分类', 'All meetings'),
      active_date: filter.dealLanguage('全部时间', 'All time'),
      anchor_list: [],
    }
  },
  components: {
    PageHeader,
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      user_key: (state) => state.user_key,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  created() {
    this.getActExhibitionGuest()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('演讲嘉宾-2025VB100大会', 'Speaker-2025VB100 Conference'),
      linkurl: this.vbef_path + '/guests',
      
    })
  },
  methods: {
    changeAssort(item) {
      this.active_assort = item
      this.getActExhibitionGuest()
    },
    changeDate(item) {
      this.active_date = item
      this.getActExhibitionGuest()
    },
    goDetail(id) {
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: id,
        },
      })
    },
    async getActExhibitionGuest() {
      let res = await getActExhibitionGuest({
        actId: this.activityId,
        assortName: (this.active_assort == '全部分类' || this.active_assort == 'All meetings') ? '' : this.active_assort,
        dateName: (this.active_date == '全部时间' || this.active_date == 'All time') ? '' : this.active_date,
        languageType: this.language == 'zh' ? 0 : 1
      })
      if (res.code == 0) {
        this.$set(this.$data, 'froum_list', res.data.activityGuests)
        this.froum_list.map((a) => {
          this.anchor_list.push({
            id: a.activityId,
            name: a.activityName,
          })
          if (a.forumPlaceJson) {
            let place = JSON.parse(a.forumPlaceJson)
            let forum = ''
            if (place.level1_show == 1 && place.place_level1) forum += place.place_level1
            if (place.level2_show == 1 && place.place_level2) forum += ' ' + place.place_level2
            if (place.level3_show == 1 && place.place_level3) forum += ' ' + place.place_level3
            this.$set(a, 'forumPlace', forum)
          } else {
            this.$set(a, 'forumPlace', '')
          }
        })
        if (this.first_load == 0) {
          this.assort_list = [...this.assort_list, ...res.data.assortNames]
          this.date_list = [...this.date_list, ...res.data.dateNames]
        }
        this.first_load = 1
      }
    },
  },
  watch: {
    language(newVal,oldVal ) {
      if(newVal == 'zh') {
        this.assort_list = ['全部分类']
        this.date_list = ['全部时间']
        this.active_assort = '全部分类'
        this.active_date = '全部时间'
      } else {
        this.assort_list = ['All meetings']
        this.date_list = ['All time']
        this.active_assort = 'All meetings'
        this.active_date = 'All time'
      }
      this.first_load = 0
      this.getActExhibitionGuest()
    }
  }
}
</script>
<style lang='stylus' scoped>
.mobile-container
  >>>.main-header
    margin-bottom 0.2rem
  >>>.van-sticky
    box-shadow 0 .04rem .1rem 0 rgba(0, 0, 0, 0.1)
  >>>.van-tabs__nav--line
    padding 0 0.4rem
    .van-tab
      margin-right 0.28rem
      padding-bottom 0.12rem
      &.van-tab--active
        position relative
        &::before
          content ''
          position absolute
          bottom 0.17rem
          width 100%
          border-bottom 0.02rem solid #4e77df
    .van-tabs__line
      width 0
      height 0
  .filter-tag
    padding 0 0.4rem 0.2rem
    display flex
    flex-wrap wrap
    &-item
      flex 0 0 1.6rem
      height 0.6rem
      border 1px solid #FA5A00
      display flex
      justify-content center
      align-items center
      font-size 0.24rem
      color #FA5A00
      margin-bottom 0.1rem
      &:not(:nth-of-type(4n))
        margin-right calc(((100% - 6.4rem) / 3))
    &-active
      background #FA5A00
      color #fff
.froum-wrapper
  .froum-base
    height 1.1rem
    background #80A4FF
    padding 0.2rem 0.4rem 0.13rem
    font-size 0.28rem
    color #FFFFFF
    position relative
    .location
      position absolute
      right 0.4rem
  .froum-speakers
    padding 0.2rem 0.4rem 0.13rem
    display flex
    justify-content space-between
    flex-wrap wrap
    &-item
      height 1rem
      flex 0 0 48%
      display flex
      margin-bottom 0.4rem
      .speaker-img
        height 1rem
        width 1rem
        position relative
        .photo
          width 1rem
          height 1rem
          img
            height 100%
            max-width 100%
        .logo
          width 0.4rem
          height 0.4rem
          background #FFFFFF
          box-shadow 0px 0.03rem 0.08rem 0px rgba(0, 0, 0, 0.16)
          display flex
          align-items center
          justify-content center
          position absolute
          bottom -0.2rem
          right -0.2rem
          img
            max-width 100%
            max-height 100%
      .speaker-info
        padding-left 0.1rem
        .speaker-name
          span
            display inline-block
            width 0.02rem
            height 0.24rem
            background #4E77DF
            margin-right 0.06rem
            font-size 0.24rem
            color #333333
        .speaker-title
          font-size 0.22rem
          color #666666
          margin-top 0.09rem
          display -webkit-box
          overflow hidden
          text-overflow ellipsis
          word-break break-all
          -webkit-box-orient vertical
          -webkit-line-clamp 2
</style>